// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gbnl-text-area.form-control {\n  height: 150px;\n  padding: 15px;\n  resize: none;\n}", "",{"version":3,"sources":["webpack://src/components/TextArea/_textarea.scss"],"names":[],"mappings":"AAEE;EACE,aAAA;EACA,aAAA;EACA,YAAA;AADJ","sourcesContent":[".gbnl-text-area {\n\n  &.form-control {\n    height: 150px;\n    padding: 15px;\n    resize: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
